import config from '@/config';
import {LooseObject} from '@/types';
import TokenStorage from '@/packages/auth/TokenStorage';
import CookieStorage from '@/packages/auth/CookieStorage';

const drivers: LooseObject = {
  token: TokenStorage,
  cookie: CookieStorage,
};

const driver: string = config.auth.driver;

const storage = drivers[driver];

export default storage;
